import { call, put, race, take, takeLeading } from 'redux-saga/effects';
import actions from '../actions';
import { getServiceProvider, IServiceProvider } from '../../../services';
import { TourCode } from '../../../models';
import { requireUserOrThrow } from '../../utils/sagas';
import { ActionType } from '../../../utils/reduxUtils';

const fetchStatisticsSaga = takeLeading(actions.fetchStatistics.request.type, function* (
  action: ActionType<typeof actions.fetchStatistics.request>
) {
  yield race({
    statistics: call(fetchStatistics, action.payload),
    cancelled: take(actions.fetchStatistics.cancel.type),
  });
});

function* fetchStatistics(tourCode: TourCode) {
  const serviceProvider: IServiceProvider = yield getServiceProvider();

  try {
    yield requireUserOrThrow();
    const statistics = yield serviceProvider.api.fetchTourStatistics(tourCode);
    yield put(actions.fetchStatistics.success(statistics));
  } catch (e) {
    yield put(actions.fetchStatistics.failure(e));
    serviceProvider.analyticsService.logError(e);
  }
}

const sagas = [fetchStatisticsSaga];

export default sagas;
